<template>
  <div class="login-wrapper">
    <auth-hero></auth-hero>

    <div class="flex-grow-1 d-flex flex-column align-center justify-center">
      <div class="full-width">
        <div class="d-flex align-center justify-center flex-wrap">
          <span class="text-h4 text-center py-2 pt-4 font-weight-bold text-secondary">
            Internal User Sign in
          </span>
        </div>
        <login-form></login-form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AuthHero from '@/components/auth/components/AuthHero.vue';
import LoginForm from '@/components/auth/components/LoginForm.vue';

export default defineComponent({
  name: 'LoginPage',
  components: {
    AuthHero,
    LoginForm
  }
});
</script>

<style lang="scss">
.login-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.hero {
  position: relative;
  width: 737px;
  max-width: 40%;
  min-width: 300px;

  .image-group {
    position: absolute;
    max-width: 100%;
    min-width: 150px;
    width: 40%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .opendock-logo {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    img {
      width: 100%;
    }
  }

  .auth-page-tag {
    position: absolute;
    bottom: 5rem;
    padding: 2rem;
    width: 100%;
    text-align: center;
    color: white;
    font-size: 16px;
  }
}

.auth-content {
  max-width: 450px;
}

.login-page-hero {
  width: auto;
  height: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('/public/images/auth_bg.png');
  background-size: cover;
  background-position: center center;
}

@media (max-width: 768px) {
  .login-wrapper {
    flex-direction: column;
  }
  .hero {
    width: 100% !important;
    height: 200px;
    max-width: 100% !important;

    .auth-page-tag {
      bottom: 0;
    }

    .login-page-hero {
      min-height: auto;
    }
  }
}
</style>
